// extracted by mini-css-extract-plugin
export default {"root":"AssetsPrice_root__yvvO+"};